export interface Immunization {
  immunizationDate: string;
  immunizationName: string;
  immunizationId: string;
  immunizationNcid: string;
  reaction: string;
  source: string;
  immunizationSeries: string;
}

export interface Allergy {
  id: string;
  name: string;
  category: string;
  infoSource: string;
  onsetDate: string;
  recordedDate: string;
  status: string;
  reaction: string;
  comments: string;
  lastUpdated: string;
}

export interface Procedure {
  id: string;
  name: string;
  encounterId: string;
  datePerformed: string;
  code: string;
  status: string;
  performer: string;
  location: string;
  notes: string;
  lastUpdated: string;
}

export interface MedicalHistoryData {
  id: string;
  name: string;
  reaction?: string;
  date: string;
  comments?: string;
  location?: string;
  provider?: string;
  lastUpdated?: string;
  category?: string;
}

export interface Problem {
  id: string;
  name: string;
  patient: null | string;
  onsetDate: Date;
  provider: null | string;
  status: null | string;
  diagnosis: DiagnosisCodingObject;
  category: DiagnosisCodingObject;
  confirmation: string;
  comments: null | CommentsObject;
}

export enum Category {
  ALCOHOL = 'alcohol',
  SUBSTANCES_USE = 'substanceUse',
  TOBACCO = 'tobacco',
  SEXUAL_GENDER = 'sexualGender',
  HOME_ENV = 'homeEnvironment',
  EMPLOYMENT_SCHOOL = 'employmentSchool',
  OTHER = 'other'
}

export type Categories =
  | Category.ALCOHOL
  | Category.SUBSTANCES_USE
  | Category.TOBACCO
  | Category.SEXUAL_GENDER
  | Category.HOME_ENV
  | Category.EMPLOYMENT_SCHOOL
  | Category.OTHER;

export type SocialHistoryCategories = {
  [C in Categories]: SocialHistory[];
};

export interface SocialHistory {
  id: string;
  dateIssued: string;
  lastUpdated: string;
  status: string;
  description: string | null;
  text: string | null;
  code: string | null;
  category: string;
  relatedDataRef: RelatedDataRef[] | null;
  patientId: string;
  name: string;
}

export interface RelatedDataRef {
  observationId: string;
}

export interface CommentsObject {
  id: string;
  description: string;
}

export interface DiagnosisCodingObject {
  coding: CodingDetailsObject[];
  text: string;
}

export interface CodingDetailsObject {
  system: string;
  code: string;
  display: string;
}

export interface ShareAllergies {
  toAddress: string;
  message: string;
  useSecureEmail: boolean;
  contactPhoneNumber: string;
  subject: string;
}

export interface ShareImmunizations {
  toAddress: string;
  message: string;
  useSecureEmail: boolean;
  contactPhoneNumber: string;
  subject: string;
}

export interface ShareProblems {
  toAddress: string;
  message: string;
  useSecureEmail: boolean;
  contactPhoneNumber: string;
  subject: string;
}

export interface ShareProcedures {
  toAddress: string;
  message: string;
  useSecureEmail: boolean;
  contactPhoneNumber: string;
  subject: string;
}

export interface ShareSocialHistory {
  toAddress: string;
  message: string;
  useSecureEmail: boolean;
  contactPhoneNumber: string;
  subject: string;
}

export interface ShareMedicalHistory {
  toAddress: string;
  message: string;
  useSecureEmail: boolean;
  contactPhoneNumber: string;
  subject: string;
}
